import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login   from './pages/Login';
import AppMain from './pages/AppMain';

function RotaProtegida({ children }) {
  const { usuario, carregando } = useAuth();
  if (carregando) return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1a1f2e' }}>
      <div style={{ textAlign: 'center', color: '#fff' }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: '#25D366', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
          <i className="ti ti-brand-whatsapp" style={{ fontSize: 24 }} />
        </div>
        <p style={{ fontSize: 14, opacity: 0.5 }}>Carregando Chat MJ...</p>
      </div>
    </div>
  );
  return usuario ? children : <Navigate to="/login" replace />;
}

function RotaPublica({ children }) {
  const { usuario, carregando } = useAuth();
  if (carregando) return null;
  return usuario ? <Navigate to="/" replace /> : children;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<RotaPublica><Login /></RotaPublica>} />
        <Route path="/*"     element={<RotaProtegida><AppMain /></RotaProtegida>} />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);
